<template>
  <rest-list-column
    :prop="prop"
    :title="title"
    :width="width"
    :min-width="minWidth"
    :formatter="formatter"
    :filter-options="filterOptions"
    :sortable="sortable"
    :editable="editable"
    :tooltip-text="tooltipText"
    :filter-input="false"
  >
    <template slot="input-edit" slot-scope="{ model }">
      <slot name="input-edit" :model="model">
        <el-switch v-model="model[prop]"></el-switch>
      </slot>
    </template>
  </rest-list-column>
</template>

<script>
import RestListColumn from '@/common/components/rest/RestListColumn'

export default {
  name: 'RestListColumnBoolean',

  components: { RestListColumn },

  props: {
    prop: {
      type: String,
      required: true
    },

    title: {
      type: String,
      required: true
    },

    width: {
      type: Number,
      required: false
    },

    minWidth: {
      type: Number,
      required: false
    },

    activeLabel: {
      type: String,
      required: false,
      default: 'Yes'
    },

    inactiveLabel: {
      type: String,
      required: false,
      default: 'No'
    },

    includeNaLabel: {
      type: Boolean,
      required: false,
      default: false
    },

    naLabel: {
      type: String,
      required: false,
      default: 'N/A'
    },

    sortable: {
      required: false
    },

    editable: {
      type: Boolean,
      required: false,
      default: false
    },

    tooltipText: {
      type: String,
      required: false
    },

    filterable: {
      type: Boolean,
      required: false,
      default: true
    }
  },

  computed: {
    filterOptions() {
      if (!this.filterable) {
        return null
      }
      const options = {
        0: this.inactiveLabel,
        1: this.activeLabel
      }

      if (this.includeNaLabel) {
        options['N/A'] = this.naLabel
      }

      return options
    }
  },

  methods: {
    formatter(value) {
      if (this.includeNaLabel && value === 'N/A') return this.naLabel

      return value ? this.activeLabel : this.inactiveLabel
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/common/components/rest/RestListColumnBoolean.vue